var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"clearable":""},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.orgId,attrs:{"label":item.name,"value":item.orgId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }